import { useDispatch } from "react-redux";
import { setLoader } from "../../../Store/Slice/techsbookSlice";
import { useLazyGetCertificatesQuery } from "../../../Store/Builder/dashboard.api";
import showToast from "../../Hooks/toast";
import { setCertificates } from "../../../Store/Slice/dashboardSlice";

const useGetCertificates = () => {
  const dispatch = useDispatch();
  const [getCertificates] = useLazyGetCertificatesQuery();
  const get = () => {
    dispatch(setLoader(true));
    getCertificates()
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        const formatted = res?.map((item) => {
          return {
            ...item,
            value: item?.id,
            label: item?.name,
          };
        });
        dispatch(setCertificates(formatted));
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error", "error");
      });
  };

  return {
    get,
  };
};

export default useGetCertificates;
